import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public http: HttpClient) {
  }

  appendAccessToken(headers: HttpHeaders) {
    let token = sessionStorage.getItem("SESSION_TOKEN");
      //console.log('AccessToken ', token);
      // encode this in base64 : ABOUBA:Orange2017
      const encoded = btoa(`ABOUBA:Orange2017`);
      headers = headers.set('Authorization', `Basic ${encoded}`);
    return headers;
  }

  // addCommonHeaders()  {
  //   let head = new HttpHeaders({'Content-Type': 'application/json'});
  //   let token = sessionStorage.getItem("SESSION_TOKEN");
  //   console.log('***************token 2: ***********', token);
  //   if(token === null) token = "";
  //   head = head.set('Authorization', `Basic ${token}`);
  //   return {headers: head} as any ;
  // }

  addCommonHeaders(headers: HttpHeaders) {

    // headers = headers.set('Content-Type', 'application/json');
   // console.log('this.store.data.login ', this.store.data.login);
    // if (this.store.data && this.store.data.login) {
    //   headers = headers.set('__login__', this.store.data.login);
    // }
    return headers;
  }

  get(endpoint: string, reqOpts?: any, secure: boolean = true) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    // if (params) {
    //   reqOpts.params = new HttpParams();
    //   for (const k of Object.keys(params)) {
    //     reqOpts.params = reqOpts.params.set(k, params[k]);
    //   }
    // }
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
      //console.log('secure options:', reqOpts);
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    //console.log('options:', reqOpts);
    return this.http.get(endpoint.replace(/^\/+/, ''), reqOpts).pipe(share(), catchError(this.handleError));
  }
 
  post(endpoint: string, body: any, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());

    //console.log("POST URL======"+this.url + '/' + endpoint.replace(/^\/+/, '') );
    //console.log(JSON.stringify(body));

    return this.http.post(endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(share(), catchError(this.handleError));
  }

  put(endpoint: string, body: any, reqOpts?: any, secure = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.put(endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(catchError(this.handleError));
  }

  delete(endpoint: string, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.delete(endpoint.replace(/^\/+/, ''), reqOpts).pipe(share(), catchError(this.handleError));
  }

  patch(endpoint: string, body: any, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.patch(endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(share(), catchError(this.handleError));
  }

  private handleErrorOld(error: HttpErrorResponse) {
    console.log('Error', error);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError((error.error && error.error.message) ||
      'Une erreur innatendue est survenue !');
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error ** api: +++++++++++++++++++++++', error);
    console.log("=====error===="+JSON.stringify(error));
    
    if (error.status === 401) {
      // alert('600');
      // login out
    localStorage.clear();
    sessionStorage.clear();
    window.location.assign('/#/login');
    }
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    
    // return an observable with a user-facing error message
    return throwError({
      
      //message: (error.error && error.error.message) || 'Something bad happened; please try again later.'
      //message: ( (error.error && error.error.message) || (error.error && JSON.parse(error.error) && JSON.parse(error.error).message) ) || 'Une erreur innatendue est survenue !'
      message : error.error && (error.error.message || (typeof error.error === 'string' && JSON.parse(error.error).message)) || 'Une erreur innatendue est survenue !'
    });
  }
  


}
